















































































































































































import Accordion from "@/components/shared/Accordion.vue";
import SearchPagination from "@/components/shared/SearchPagination.vue";
import i18n from "@/lang/i18n";
import { Page } from "@/model/component.model";
import { FunctionalityDTO, LoginHistoryDTO } from "@/model/data.model";
import moment from "moment";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { getEventsTable, getEventsTypes } from "@/services/AuthService";
import { parseDateAsUTC } from "@/services/Helpers";

@Component({
  components: {
    MbeSearchPagination: SearchPagination,
    Accordion
  }
})
export default class LoginHistory extends Vue {
  list: LoginHistoryDTO[] = [];
  currentPage = 1;
  pageSize = 25;
  sort: string[] = [];
  dateFilter: moment.Moment[] = [moment().subtract(1, "month"), moment()];
  showFilters = true;
  pagination = {
    first: false,
    last: false,
    number: 0,
    numberOfElements: 0,
    size: 25,
    sort: null,
    totalElements: 0,
    totalPages: 0,
    content: []
  } as Page;
  filters = {
    events: [] as string[],
    fromData: "" as string,
    toData: "" as string,
    username: "" as string,
    eventsRawValue: [] as string[]
  };
  eventOptions = [] as string[];
  get currentPageIndex() {
    return this.currentPage - 1;
  }

  async loadTable(filters: any) {
    try {
      const res = await getEventsTable(
        this.currentPageIndex,
        this.pageSize,
        filters
      );
      this.pagination = res;
      this.list = this.pagination.content;
      if (this.list) {
        this.list.forEach(element => {
          if (element.creationDate) {
            element.creationDate = parseDateAsUTC(
              element.creationDate.toString()
            );
          }
          if (
            element.impersonation_chain &&
            element.impersonation_chain.length > 0
          ) {
            element.impersonator = element.impersonation_chain[0].impersonator;
          }
        });
      }
    } catch (err) {
      console.error(err);
    }
  }

  async created() {
    const events = await getEventsTypes();
    this.eventOptions = events;
    const oneMonthAgo = moment().subtract(1, "month");
    this.filters.fromData = oneMonthAgo.startOf("day").toISOString();
    this.filters.toData = moment()
      .endOf("day")
      .toISOString();
    await this.loadTable(this.filters);
  }

  executeSearch() {
    this.loadTable(this.filters);
  }

  handleEventChange(value: string) {
    if (value !== "") {
      this.filters.eventsRawValue = [
        this.eventOptions.find(
          item => this.$t(`event_type.${item}`) === value
        ) as string
      ];
      this.filters.events = [value];
    } else {
      this.filters.events = [];
    }
    this.loadTable(this.filters);
  }

  clearEvent() {
    this.filters.events = [];
    this.loadTable(this.filters);
  }

  datePickerOptions(date: any) {
    const newdate = new Date();
    return {
      disabledDate(time: any) {
        return time.getTime() > Date.now();
      },
      shortcuts: [
        {
          text: i18n.t("today"),
          onClick(picker: any) {
            picker.$emit("pick", new Date());
          }
        },
        {
          text: i18n.t("first_day_month"),
          onClick(picker: any) {
            picker.$emit(
              "pick",
              new Date(newdate.getFullYear(), newdate.getMonth(), 1)
            );
          }
        }
      ],
      firstDayOfWeek: 1
    };
  }

  handleDateChange(value: any) {
    if (value && value.length === 2) {
      this.filters.fromData = moment(
        value[0],
        "ddd MMM DD YYYY HH:mm:ss"
      ).toISOString();
      this.filters.toData = moment(
        value[1],
        "ddd MMM DD YYYY HH:mm:ss"
      ).toISOString();
    } else {
      this.filters.fromData = "";
      this.filters.toData = "";
    }
    this.loadTable(this.filters);
  }

  async open(item: FunctionalityDTO) {
    await this.$router.push({
      name: "FunctionalityManagementItem",
      params: {
        id: String(item.id)
      }
    });
  }

  async openRoleFunctionalityPage(item: FunctionalityDTO) {
    await this.$router.push({
      name: "RoleFunctionality",
      params: {
        id: String(item.id)
      }
    });
  }

  async create() {
    await this.$router.push({
      name: "FunctionalityManagementItem"
    });
  }
}
